import React from "react";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";

import CardActionArea from "@material-ui/core/CardActionArea";

const TerminalCard = (props) => {
  const {
    name,
    model,
    total,
    classes,
    location,
    selected,
    status,
    terminal,
  } = props;
  let cardClassName = `${classes.card}`;
  if (selected) {
    if (terminal.model === "100"){
      cardClassName = `${classes.card} ${classes.kisanSelected}`;
    } else {
      cardClassName = `${classes.card} ${classes.cardSelected}`;
    }
  };

  const currencyFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  const formattedTotal = currencyFormat.format(total);

  return (
    <Card className={cardClassName}>
      <CardActionArea
        onClick={() => {
          props.handleTerminalChange(terminal);
        }}
      >
        <CardHeader
          classes={{
            title: classes.title,
            subheader: classes.subheader,
          }}
          avatar={
            <Avatar
              aria-label="Recipe"
              className={
                status === "ok" || status === undefined
                  ? (terminal.model === "100" ? classes.avatarBlue : classes.avatarOk) 
                  : classes.avatarError
              }
            >
              {model}
            </Avatar>
          }
          title={name}
          subheader={
            <div>
              <Typography component="p" className={classes.subTitle}>
                {location.LocationName.replace(/_/g, " ")}
              </Typography>
              <Typography component="p" className={classes.subTitle}>
                Machine Total: {formattedTotal}
              </Typography>
            </div>
          }
        />
      </CardActionArea>
    </Card>
  );
};

export default TerminalCard;



// WEBPACK FOOTER //
// ./src/components/Terminal/TerminalCard.jsx